/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Waiting_ProviderInputs */

const cs_tasks_protocol_waiting_provider = /** @type {(inputs: Tasks_Protocol_Waiting_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeká se na potvrzení dokončení od poskytovatele podpisu.`)
};

const en_tasks_protocol_waiting_provider = /** @type {(inputs: Tasks_Protocol_Waiting_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for the signing provider to confirm completion.`)
};

/**
* | output |
* | --- |
* | "Waiting for the signing provider to confirm completion." |
*
* @param {Tasks_Protocol_Waiting_ProviderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_waiting_provider = /** @type {((inputs?: Tasks_Protocol_Waiting_ProviderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Waiting_ProviderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_waiting_provider(inputs)
	return cs_tasks_protocol_waiting_provider(inputs)
});